/* Tatagaltier collection page — filter panel behaviour.
   Desktop (>=750px): the sticky rail can be hidden to widen the grid; choice
   persists in localStorage. Individual groups collapse natively via <details>.
   Mobile (<750px): the rail becomes a left slide-in sheet opened by "Show
   Filters" (modal: overlay, Esc, focus trap, scroll lock). The drawer CSS is
   gated on the .tata-has-drawer class this script adds, so without JS the
   filters render inline and stay reachable. */
(function () {
  var KEY = 'tata:filters-hidden';
  var mqMobile = window.matchMedia('(max-width: 749px)');

  function focusables(container) {
    return Array.prototype.slice
      .call(container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ))
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }

  function init(root) {
    var layout = root.querySelector('.tata-collection__layout');
    if (!layout) return;
    var filters = root.querySelector('[data-tata-filters]');
    var overlay = root.querySelector('[data-filters-overlay]');
    var hideBtn = root.querySelector('[data-filters-hide]');
    var showBtn = root.querySelector('[data-filters-show]');
    var closeBtn = root.querySelector('[data-filters-close]');

    if (filters) root.classList.add('tata-has-drawer'); // enable mobile drawer CSS

    /* ---- Desktop rail hide/show (widen the grid) ---- */
    function setHidden(hidden) {
      layout.classList.toggle('is-filters-hidden', hidden);
      if (showBtn && !mqMobile.matches) showBtn.hidden = !hidden;
      if (hideBtn) hideBtn.setAttribute('aria-expanded', String(!hidden));
      try { localStorage.setItem(KEY, hidden ? '1' : '0'); } catch (e) {}
    }
    if (hideBtn) hideBtn.addEventListener('click', function () { setHidden(true); });

    /* ---- Mobile drawer ---- */
    var lastFocus = null;

    function onKeydown(e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab' || !filters) return;
      var f = focusables(filters);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function openDrawer() {
      if (!filters) return;
      lastFocus = document.activeElement;
      filters.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      filters.setAttribute('role', 'dialog');
      filters.setAttribute('aria-modal', 'true');
      filters.setAttribute('tabindex', '-1');
      document.body.style.overflow = 'hidden';
      if (showBtn) showBtn.setAttribute('aria-expanded', 'true');
      // defer focus a frame — the panel flips from visibility:hidden on open,
      // and a hidden element can't take focus yet
      requestAnimationFrame(function () { (closeBtn || filters).focus(); });
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      if (!filters) return;
      filters.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      filters.removeAttribute('role');
      filters.removeAttribute('aria-modal');
      document.body.style.overflow = '';
      if (showBtn) showBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (showBtn) showBtn.addEventListener('click', function () {
      if (mqMobile.matches) openDrawer();
      else { setHidden(false); if (hideBtn) hideBtn.focus(); }
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Close the sheet as soon as Apply submits, so it doesn't linger open
    // during the reload into the filtered page.
    var form = filters ? filters.querySelector('.tata-filters__form') : null;
    if (form) form.addEventListener('submit', function () { closeDrawer(); });

    function onMqChange() {
      if (mqMobile.matches) {
        if (showBtn) showBtn.hidden = false; // sheet trigger always available on mobile
      } else {
        closeDrawer();
        if (showBtn) showBtn.hidden = !layout.classList.contains('is-filters-hidden');
      }
    }
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', onMqChange);
    else if (mqMobile.addListener) mqMobile.addListener(onMqChange);

    /* ---- Initial state ---- */
    try { if (localStorage.getItem(KEY) === '1') setHidden(true); } catch (e) {}
    if (mqMobile.matches && showBtn) showBtn.hidden = false;
  }

  document.querySelectorAll('[data-tata-collection]').forEach(init);
})();
